import React from 'react';
import pencil from "../../../../../../assets/icons/edit.svg";
import { PillAnchor } from "./styles";

const EditButton = (props) => {
    return (
        <PillAnchor id={props.id ? props.id:'anrEdit'} disabled={props.disabled} onClick={props.onClick}>
            <span>Edit</span>
            <img src={pencil} className="ml-05" />
        </PillAnchor>
    );
};

export default EditButton;